export default __webpack_public_path__ + "static/time-axis-with-irregular-intervals-6f29b941af8c489d33deb6e4d9029cd5.png";